import { useRoute } from 'vue-router'
import { TravelDirection } from '@/shared/types/common.types'

export const useFlowDirection = () => {
  const route = useRoute()
  const isInboundRoute: boolean = route.path.includes(TravelDirection.INBOUND.toLowerCase())
  const isOutboundRoute: boolean = route.path.includes(TravelDirection.OUTBOUND.toLowerCase())
  return { isInboundRoute, isOutboundRoute }
}
